import OrganizationsTable from "../../components/tables/OrganizationsTable";

export default function Organizations() {
  return (
    <div className="w-full min-h-full overflow-auto h-full">
      <OrganizationsTable />
    </div>
  )
}